import { listStoreBuilder } from '@/main/store/pages/list/builder';
import { convertToObjects } from '@/main/utils/table';

import { NAME, CRUMB_LABEL_KEY, COLUMN_STAV_FYZ } from '../constants';
import { apiProvider } from '../api';
import { listActions } from './types';

export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {},
	filter: {},
	tableSetting: {
		isEditable: true,
		columnSettings: {
			[COLUMN_STAV_FYZ]: { isEditable: true },
		},
	},
	rowDetail: null,
	localState: {},
	extraActions: {
		[listActions.SAVE_TABLE]: async ({ state, commit }) => apiProvider.saveTable(convertToObjects(state.table)),
	},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
		canEdit: null as boolean | null,
		afterRowSelection: () => {},
	},
});
